<template>
  <div class="navbar">
    <img src="@/assets/logo.svg" alt="DataCraft Studios" class="navbar__logo" loading="lazy"/>
    <div class="navbar__menu-icon" @click="toggleMenu">
      <img src="@/assets/icon/menu.svg" alt="Menu" />
    </div>
    <ul :class="{ navbar__menu: true, 'navbar__menu--active': isMenuOpen }">
      <li>
        <router-link to="/" class="navbar__menu-item" @click="closeMenu">HOME</router-link>
      </li>
      <li>
        <router-link to="/servicios" class="navbar__menu-item" @click="closeMenu">SERVICES</router-link>
      </li>
      <li>
        <router-link to="/portfolio" class="navbar__menu-item" @click="closeMenu">PORTFOLIO</router-link>
      </li>
      <li>
        <router-link to="/blog" class="navbar__menu-item" @click="closeMenu">BLOG</router-link>
      </li>
    </ul>
    <a href="#contact" class="navbar__button">COMENZAR</a>
  </div>
</template>

<script>
export default {
  name: "CxNavBar",
  data() {
    return {
      menuItems: ["HOME", "SERVICIOS", "PORTFOLIO", "BLOG"],
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
  },
};
</script>

<style scoped>
/* ... Estilos para la versión de escritorio ... */
@import "@/css/variables.css";

.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: -5px;
  background-color: var(--color-background);
  padding: 10px 0 0;
  z-index: 10;
}

.navbar__logo {
  width: 38px;
  height: 38px;
}

.navbar__menu-icon {
  display: none;
}

.navbar__menu-icon img {
  width: 24px;
  height: 24px;
  cursor: pointer;
  fill: var(--color-accent);
}

.navbar__menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

/* .navbar__menu--deactive {
  display: none;
} */

.navbar__menu--active {
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 3rem;
  background-color: var(--color-background);
  opacity: 0.9;
  align-items: center;
  justify-content: center;
  z-index: 100;
}


.navbar__menu-item {
  margin: 0 10px;
  color: var(--color-accent);
  font-family: var(--font-sans);
  font-weight: bold;
  cursor: pointer;
}

.navbar__menu-item:hover {
  color: var(--color-primary);
  transform: scale(1.1);
}

.navbar__button {
  margin: 10px;
  border-radius: 20px;
  width: 136px;
  height: 38px;
  background-color: var(--color-accent);
  color: var(--color-background);
  font-weight: bold;
  font-family: var(--font-sans);
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.navbar__button:hover {
  background-color: var(--color-primary);
  cursor: pointer;
}

.navbar__menu-item,
.navbar__button {
  text-decoration: none;
  /* Puedes agregar más estilos si es necesario */
}

/* Media query para pantallas pequeñas */
@media (max-width: 768px) {
  .navbar__menu-icon {
    display: block;
    z-index: 1000;
    background-color: var(--color-accent);
    position: absolute;
    right: 10px;
    top: 15px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .navbar__menu-icon img {
    width: 24px;
    height: 24px;
    cursor: pointer;
    fill: var(--color-primary);
  }

  .navbar__menu {
    display: none;
  }

  .navbar__menu--active {
    display: flex;
  }

  .navbar {
    flex-direction: column;
    align-items: flex-start;
  }

  .navbar__menu-item {
    margin: 10px 0;
  }

  .navbar__button {
    margin: -35px auto;
    width: 60%;
  }
}

@media (min-width: 768px) {
  .navbar__menu--active {
    display: none;
  }
}
</style>
